var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"mySwiper",staticClass:"swiper-container home_banner"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.List),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide"},[_c('img',{attrs:{"src":item.img}})])}),0),_c('div',{staticClass:"swiper-pagination home_pagination"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }